import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import {createStore, applyMiddleware, compose} from 'redux';
import { store } from './app/store';
import thunk from 'redux-thunk';
import reducers from './reducers';
import App from './App';
import LeafMap from './leafMap';
import { mainListItems, secondaryListItems } from './listItems';
import Odors from './odorTracker';
import SignUp from './signUp';
import Admin from './Admin/Admin';
import Login from './Auth/Login';
import Register from './Auth/Register';
import CreateProject from './Project/createProject';
import CreateDevice from './Device/createDevice';
import EditDevice from './Device/editDevice';
import PublicProject from './publicProject';
import IFrame from './iframe';
import "./leaflet/dist/leaflet.css";




import Project from './Project/project';




import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";
//import reportWebVitals from './reportWebVitals';

//const store = createStore(reducers, compose(applyMiddleware(thunk)))

ReactDOM.render(

  <Provider store={store}>
  <Router basename="/">
    <Routes>
      <Route path="/" element={<App />} />
        <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
      <Route path="/leaf" element={<Odors />} />
        <Route path="/admin" element={<Admin />} />
          <Route path="/createProject" element={<CreateProject />} />
            <Route path="/createDevice" element={<CreateDevice />} />
            <Route path="/editDevice" element={<EditDevice />} />
            <Route path="/publicProject" element={<PublicProject />} />
            <Route path="/iframe" element={<IFrame />} />


              <Route path="/project" element={<Project />} />
    </Routes>
  </Router>
  </Provider>,
   document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
